import { render, staticRenderFns } from "./PaymentGateways.vue?vue&type=template&id=603f1a3c"
import script from "./PaymentGateways.vue?vue&type=script&lang=js"
export * from "./PaymentGateways.vue?vue&type=script&lang=js"
import style0 from "./PaymentGateways.vue?vue&type=style&index=0&id=603f1a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports